import { computed, ComputedRef } from 'vue'
import { useStore } from 'vuex'

import { JudgeRecord } from '@/domain/entities/judge/judgeRecord'
import { HistoryListModuleName } from '@/store/modules/modules'

export class HistoryListViewModel {
  private store = useStore()

  historyList: ComputedRef<{ [judgeId: number]: JudgeRecord }> = computed(
    () => this.store.getters[`${HistoryListModuleName}/historyList`]
  )
  isLoading: ComputedRef<boolean> = computed(() => this.store.getters[`${HistoryListModuleName}/isLoading`])
  error: ComputedRef<Error | null> = computed(() => this.store.getters[`${HistoryListModuleName}/error`])

  setHistoryList(list: { [judgeId: number]: JudgeRecord }): void {
    this.store.commit(`${HistoryListModuleName}/setHistoryList`, { list })
  }

  async fetchHistoryList(userId: string, problemId: string, pageIndex: number): Promise<void> {
    await this.store.dispatch(`${HistoryListModuleName}/fetchHistoryList`, {
      userId,
      problemId,
      pageIndex
    })
  }
}
